(function(){
  'use strict';

  /* UAT/prod switch. Renders as false when the theme does not define the
     deployment_is_uat setting, instead of breaking the script. */
  var IS_UAT = window.WZC_IS_UAT === true;

  /* ==========================================================================
     CONFIG  (v27 logic)
     ========================================================================== */
  var CONFIG = {

    privacyUrl: 'https://wombi.us/pages/terms-and-conditions?',

    phone:        '+1 888-448-2880',
    phoneHref:    'tel:+18884482880',

    exfleetUrl:   '/pages/exfleet-tern-bikes-for-sale',

    redirects: {
      sea: '/pages/seattle',
      bay: '/pages/bay-area'
    },

    /* Booking API is DISABLED: the prod endpoint returns 500 on every POST
       (as of Sept 15). Leads are created via the Jotform lead forms below
       until L+C fixes the Apex endpoint. Flip bookingApiEnabled to true
       to restore, then remove the Jotform lead post to avoid duplicates. */
    sf: {
      bookingApiEnabled: false,
      webToLead: {
        enabled: false,
        action: 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8'
      },
      oid:        '00D9r000003H90L',
      recordType: '0129q0000004M1c',
      leadSource: 'Website - Consultation',
      currency:   'USD',
      consentField: '00N9q000000PLKo',
      utmFields: {
        utm_source:  '00NRE00000043CD',
        utm_medium:  '00NRE00000043KH',
        utm_campaign:'00NRE00000043If',
        utm_term:    '00NRE00000043Dp',
        utm_content: '00NRE00000043FR',
        utm_id:      '00NRE000000XYhF',
        gclid:       '00NRE000001GxI5'
      },
      apiUrl: (IS_UAT ?
        'https://lugandcarrie--uat.sandbox.my.salesforce-sites.com/services/apexrest/wombi/api/v2/booking' :
        'https://lugandcarrie.my.salesforce-sites.com/services/apexrest/wombi/api/v2/booking'),
      apiKey: 'dXNlcm5hbWU6MTIzNDU2Nzg5MDEyMzQ1Njc4OTAxMjM0NTY3ODkwMTIzNDU2Nzg5MA=='
    },

    calendly: {
      url: (IS_UAT ?
        'https://calendly.com/info-uat-wombi/consultation' :
        'https://calendly.com/consultation-wombi/consultation'),

      /* Custom-question prefill is DISABLED: visitors type phone, zip,
         and location directly into Calendly so answers always sit under
         the right questions for the Salesforce sync. To re-enable later,
         set prefillCustomAnswers to true and make answerMap match the
         event's live question order (1 = first question). */
      prefillCustomAnswers: false,
      answerMap: {
        phone:    1,
        zip:      2,
        location: 3
      }
    },

    /* Jotform lead forms: each creates the Salesforce Lead via that form's
       Salesforce integration. Each outcome posts to its own form:
         nearShop  = within 5 mi, call back request
         atHome    = outside 5 mi, call booking (before Calendly)
         outOfZone = waitlist
       All three forms share the same field names (from each form's Field
       Details; question numbers are baked into the names). utmFields carry
       paid-campaign attribution; each must be mapped to its Lead field in
       every form's Salesforce integration settings. */
    leadForm: {
      enabled: true,
      endpoint: 'https://submit.jotform.com/submit/',
      formIds: {
        nearShop:  '262726519994170',
        atHome:    '262575522364157',
        outOfZone: '262736987994180'
      },
      fields: {
        firstName: 'q3_name[first]',
        lastName:  'q3_name[last]',
        email:     'q4_email',
        mobile:    'q5_phoneNumber[full]',
        zip:       'q7_zipCode'
      },
      utmFields: {
        utm_source:  'q18_utm_source',
        utm_medium:  'q19_utm_medium',
        utm_campaign:'q20_utm_campaign',
        utm_term:    'q21_utm_term',
        utm_content: 'q22_utm_content',
        utm_id:      'q23_utm_id',
        gclid:       'q24_gclid',
        fbclid:      'q25_fbclid'
      }
    },

    markets: {
      la: {
        name: 'Los Angeles',
        shop: {
          label:   'Culver City shop',
          line1:   '8586 Washington Blvd',
          line2:   'Culver City, CA 90232',
          mapQuery:'8586 Washington Blvd, Culver City, CA 90232',
          phone:   '213-377-6675',
          phoneHref:'tel:+12133776675'
        },
        // TODO: replace with your polygon-verified inside-5-miles list
        nearShop: [
  '90004', '90005', '90006', '90008', '90010', '90016', '90018', '90019', '90020', '90024',
  '90034', '90035', '90036', '90038', '90043', '90048', '90056', '90064', 
  '90067', '90069', '90095', '90211', '90212', '90230', '90232'
],
        zips: [
  '90007', '90011', '90012', '90013', '90014', '90015', '90017', '90021', '90023', '90026',
  '90027', '90028', '90029', '90033', '90039', '90041', '90042', '90045', '90046', '90049',
  '90057', '90065', '90068', '90071', '90077', '90210', '90245', '90250', '90254', '90266',
  '90277', '90278', '90291', '90292', '90293', '90303', '90401', '90402', '90403', '90503',
  '90505', '91001', '91030', '91101', '91103', '91104', '91105', '91106', '91107', '91201',
  '91202', '91203', '91204', '91205', '91206', '91207', '91208', '91210', '91214', '91501',
  '91502', '91504', '91505', '91506', '92602', '92603', '92604', '92606', '92612', '92614',
  '92617', '92618', '92620','90404', '90405', '90094', '90066', '90025'
]
      }
    },

    redirectZips: {
      sea: ['98011','98033','98083','98039','98040','98004','98015','98009',
            '98006','98008','98007','98005','98052','98034','98117','98107',
            '98199','98109','98121','98101','98104','98154','98164','98174',
            '98134','98126','98116','98136','98106','98108','98118','98133',
            '98122','98145','98195','98105','98115','98125','98155','98028',
            '98144','98102','98103','98119','98177','98112'],
      bay: ['94065','94063','94062','94061','94070','94027','94025','94303',
            '94301','94304','94306','94305','94022','94024','94040','94041',
            '94043','94035','94089','94085','94086','94087','95014','95002',
            '95134','95129','95117','95130','95128','95126','95131','95110',
            '95125','95113','95192','95112','95136','95123','95111','95121',
            '95122','95116','95133','95054','95051','95053','95035','95036',
            '95132','94555','94536','94538','94539','94560']
    },

    hours: [
      { days:'Tue to Sat', time:'9:30am to 5:30pm' },
      { days:'Sun &amp; Mon', time:'Closed' }
    ]
  };

  var CITIES = {
    '90232':'Culver City, CA',
    '91101':'Pasadena, CA',
    '92101':'San Diego, CA'
  };

  /* ==========================================================================
     DOM  (hero input drives the checker; results render below the input)
     Elements are looked up fresh at click time (getInput / getOut), so the
     checker keeps working if another script redraws the hero.
     ========================================================================== */
  function getInput(){ return document.getElementById('wla-zip-input'); }
  function getOut(){   return document.getElementById('wzc-result'); }
  function getErr(){   return document.getElementById('wla-zip-error'); }
  function getRoot(){  return document.getElementById('wzc'); }

  var input  = getInput();
  var out    = getOut();
  if (!input || !document.getElementById('wla-zip-btn') || !out){
    console.warn('[wzc] zip checker elements not found on this page');
    return;
  }
  var root   = getRoot() || out;

  /* v27: the hero CSS hides #wzc with "#wzc:has(.wzc__result:empty)".
     Safari does not re-check that rule when a card is added, so the card
     stayed hidden. The script now sets the box's display directly; an
     inline style overrides that CSS rule in every browser. */
  function setResultVisible(on){
    var r = getRoot();
    if (r) r.style.display = on ? 'block' : 'none';
  }

  /* Hidden iframe that lead form posts target. Created only if the page
     doesn't already have one, so posts never open a new tab. */
  if (!document.querySelector('iframe[name="wzc-sink"]')){
    var sink = document.createElement('iframe');
    sink.name = 'wzc-sink';
    sink.title = 'wzc-sink';
    sink.setAttribute('aria-hidden', 'true');
    sink.tabIndex = -1;
    sink.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(sink);
  }

  /* ==========================================================================
     HELPERS
     ========================================================================== */
  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function isValidZip(z){ return /^\d{5}$/.test(z); }
  function cityFor(z){ return CITIES[z] || ''; }

  function setHeroErr(show){
    var e = getErr();
    if (e) e.hidden = !show;
  }
  function heroErrShowing(){
    var e = getErr();
    return e ? !e.hidden : false;
  }

  /* Results can sit below the bottom of the window on smaller screens.
     Scroll to them only when they aren't already in view. */
  function revealResult(){
    var r  = out.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (r.top < 0 || r.top > vh - 160){
      out.scrollIntoView({ behavior:'smooth', block:'start' });
    }
  }

  /* ==========================================================================
     PHONE FORMAT
     The visible field shows a fixed +1 prefix (rendered outside the input,
     not deletable) and accepts exactly 10 digits, auto-dashed as
     XXX-XXX-XXXX while typing. Two wire formats are built from those
     digits:
       phoneDashed('3105550111')   -> '+1-310-555-0111'  (Salesforce)
       phoneDashless('3105550111') -> '+13105550111'     (Calendly prefill)
     ========================================================================== */
  function phoneDigits(raw){
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    return d.slice(0, 10);
  }
  function displayDashed(d){
    if (d.length > 6)  return d.slice(0,3) + '-' + d.slice(3,6) + '-' + d.slice(6);
    if (d.length > 3)  return d.slice(0,3) + '-' + d.slice(3);
    return d;
  }
  function phoneDashed(d){   return '+1-' + d.slice(0,3) + '-' + d.slice(3,6) + '-' + d.slice(6); }
  function phoneDashless(d){ return '+1' + d; }

  /* Calendly's phone-type question validates international format.
     Used only when prefillCustomAnswers is re-enabled. */
  function normalizePhone(raw){
    var d = phoneDigits(raw);
    return d.length === 10 ? phoneDashless(d) : String(raw || '').trim();
  }

  function parseGET(param){
    try {
      var match = document.location.search.match('[?&]' + param + '=([^&]+)');
      if (!match) return '';
      return decodeURIComponent(match[1].replace(/\+/g, '%20'));
    } catch(e){ return ''; }
  }
  var UTM = {
    utm_source: parseGET('utm_source'), utm_medium: parseGET('utm_medium'),
    utm_campaign: parseGET('utm_campaign'), utm_term: parseGET('utm_term'),
    utm_content: parseGET('utm_content'), utm_id: parseGET('utm_id'),
    gclid: parseGET('gclid'), fbclid: parseGET('fbclid')
  };

  /* nearShop is checked first. The nearShop and zips lists don't overlap,
     so checking zips first sent every near-shop zip to outOfZone. */
  function classify(zip){
    if (CONFIG.redirectZips.sea.indexOf(zip) !== -1) return { outcome:'redirect', target:'sea' };
    if (CONFIG.redirectZips.bay.indexOf(zip) !== -1) return { outcome:'redirect', target:'bay' };
    var m = CONFIG.markets.la;
    if (m.nearShop.indexOf(zip) !== -1){
      return { marketKey:'la', market:m, outcome:'nearShop' };
    }
    if (m.zips.indexOf(zip) !== -1){
      return { marketKey:'la', market:m, outcome:'atHome' };
    }
    return { marketKey:null, market:null, outcome:'outOfZone' };
  }

  function track(name, payload){
    window.dataLayer = window.dataLayer || [];
    var data = { event: name };
    for (var k in payload){ if (payload.hasOwnProperty(k)) data[k] = payload[k]; }
    window.dataLayer.push(data);
  }

  function mapsUrl(query){
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(query);
  }

  /* ==========================================================================
     HTML PARTIALS
     ========================================================================== */
  function zipbar(zip){
    var city = cityFor(zip);
    return ''
      + '<div class="wzc-zipbar">'
      +   '<span class="wzc-zipbar__val">Checking <strong>' + esc(zip) + '</strong>'
      +     (city ? ' &middot; ' + esc(city) : '') + '</span>'
      +   '<button type="button" class="wzc-zipbar__change" data-wzc-reset>Change</button>'
      + '</div>';
  }

  function shopBlock(shop){
    var rows = CONFIG.hours.map(function(h){
      return '<dt>' + h.days + '</dt><dd>' + h.time + '</dd>';
    }).join('');
    var phone = shop.phone
      ? '<p class="wzc-shop__phone"><a href="' + esc(shop.phoneHref) + '">'
        + esc(shop.phone) + '</a></p>'
      : '';
    return ''
      + '<div class="wzc-shop">'
      +   '<p class="wzc-shop__name">' + esc(shop.label) + '</p>'
      +   '<p class="wzc-shop__addr">' + esc(shop.line1) + '<br>' + esc(shop.line2) + '</p>'
      +   phone
      +   '<dl class="wzc-hours">' + rows + '</dl>'
      +   '<div class="wzc-shop__links">'
      +     '<a href="' + mapsUrl(shop.mapQuery) + '" target="_blank" rel="noopener">Get directions</a>'
      +   '</div>'
      + '</div>';
  }

  function consentBlock(){
    return ''
      + '<label class="wzc-consent">'
      +   '<input type="checkbox" data-wzc-consent>'
      +   '<span class="wzc-box"></span>'
      +   '<span>I agree to receive emails, calls, and text messages from Wombi. '
      +   'I have read and agree to Wombi\'s <a href="' + esc(CONFIG.privacyUrl)
      +   '" target="_blank" rel="noopener">Privacy Policy</a> and understand my rights.</span>'
      + '</label>';
  }

  function nameFields(){
    return ''
      + '<div class="wzc-grid">'
      +   '<div class="wzc-field">'
      +     '<label class="wzc-label" for="wzc-fn">First name <span class="wzc-req">*</span></label>'
      +     '<input class="wzc-in" id="wzc-fn" data-wzc-field="firstName" type="text" autocomplete="given-name">'
      +   '</div>'
      +   '<div class="wzc-field">'
      +     '<label class="wzc-label" for="wzc-ln">Last name <span class="wzc-req">*</span></label>'
      +     '<input class="wzc-in" id="wzc-ln" data-wzc-field="lastName" type="text" autocomplete="family-name">'
      +   '</div>'
      + '</div>'
      + '<div class="wzc-field">'
      +   '<label class="wzc-label" for="wzc-em">Email <span class="wzc-req">*</span></label>'
      +   '<input class="wzc-in" id="wzc-em" data-wzc-field="email" type="email" autocomplete="email" inputmode="email">'
      + '</div>'
      + '<div class="wzc-field">'
      +   '<label class="wzc-label" for="wzc-mb">Phone number <span class="wzc-req">*</span></label>'
      +   '<div style="display:flex;align-items:stretch;gap:0;">'
      +     '<span aria-hidden="true" style="display:flex;align-items:center;padding:0 12px;'
      +       'border:1px solid #176eb0;border-right:0;border-radius:8px 0 0 8px;'
      +       'background:#eef4f9;color:#176eb0;font-weight:600;font-size:16px;'
      +       'user-select:none;">+1</span>'
      +     '<input class="wzc-in" id="wzc-mb" data-wzc-field="mobile" data-wzc-phone type="tel" '
      +       'autocomplete="tel-national" inputmode="numeric" placeholder="XXX-XXX-XXXX" '
      +       'maxlength="12" style="border-radius:0 8px 8px 0;flex:1;min-width:0;">'
      +   '</div>'
      + '</div>';
  }

  function zipField(zip, id){
    return ''
      + '<div class="wzc-field">'
      +   '<label class="wzc-label" for="' + id + '">Zip code'
      +     '<span class="wzc-hint">Carried over from your check above.</span></label>'
      +   '<input class="wzc-in" id="' + id + '" data-wzc-field="zip" value="' + esc(zip) + '" readonly>'
      + '</div>';
  }

  function errLine(){
    return '<p class="wzc-err" data-wzc-formerr></p>';
  }

  /* ==========================================================================
     OUTCOME 1  -  LA within 5 miles: shop card + callback form
     ========================================================================== */
  function renderNearShop(zip, ctx){
    var m = ctx.market;
    return ''
      + '<div class="wzc-card" data-wzc-outcome="nearShop">'
      +   zipbar(zip)
      +   '<h2 class="wzc-h">Wombi is in your neighborhood!</h2>'
      +   '<p class="wzc-sub">Come by our Culver City shop to learn more and test '
      +     'ride our bikes, or input your info below and we\'ll reach out to help '
      +     'you select the right bike and accessories.</p>'
      +   shopBlock(m.shop)
      +   '<div class="wzc-split"><span>OR</span></div>'
      +   '<p class="wzc-formhead">Have someone call me</p>'
      +   '<p class="wzc-formsub">We\'ll help you pick the right bike and accessories before you come in.</p>'
      +   '<div data-wzc-form>'
      +     nameFields()
      +     consentBlock()
      +     errLine()
      +     '<button type="button" class="wzc-btn" data-wzc-submit aria-disabled="true">SUBMIT</button>'
      +     '<p class="wzc-afterbtn">We\'ll reach out within one business day.</p>'
      +   '</div>'
      + '</div>';
  }

  function doneNearShop(zip, ctx, data){
    var m = ctx.market;
    return ''
      + '<div class="wzc-card">'
      +   zipbar(zip)
      +   '<h2 class="wzc-h">Wombi is in your neighborhood!</h2>'
      +   shopBlock(m.shop)
      +   '<div class="wzc-done">'
      +     '<div class="wzc-done__tick"></div>'
      +     '<h3 class="wzc-done__h">Got it, ' + esc(data.firstName) + '.</h3>'
      +     '<p class="wzc-done__p">A Wombi expert will call you at ' + esc(data.mobile)
      +       ' within one business day.</p>'
      +     '<ul class="wzc-done__list">'
      +       '<li>Check your email for a confirmation.</li>'
      +       '<li>Walk in any time Tuesday to Saturday, no appointment needed.</li>'
      +     '</ul>'
      +   '</div>'
      + '</div>';
  }

  /* ==========================================================================
     OUTCOME 2  -  LA outside 5 miles: at-home card + lead form + Calendly
     ========================================================================== */
  function renderAtHome(zip, ctx){
    var shop = ctx.market.shop;
    return ''
      + '<div class="wzc-card" data-wzc-outcome="atHome">'
      +   zipbar(zip)
      +   '<h2 class="wzc-h">Great news! At-home test rides are available in your area.</h2>'
      +   '<p class="wzc-lede">Here\'s how it works:</p>'
      +   '<ol class="wzc-steps">'
      +     '<li class="wzc-step">'
      +       '<span class="wzc-stepnum" aria-hidden="true">1</span>'
      +       '<p class="wzc-steptext"><strong>Schedule a call with Wombi to find your perfect e-bike.</strong></p>'
      +     '</li>'
      +     '<li class="wzc-step">'
      +       '<span class="wzc-stepnum" aria-hidden="true">2</span>'
      +       '<p class="wzc-steptext"><strong>Test ride at home and decide if you\'re ready to roll.</strong></p>'
      +     '</li>'
      +   '</ol>'
      +   '<p class="wzc-subnote">(or you can <a href="' + mapsUrl(shop.mapQuery) + '" target="_blank" '
      +     'rel="noopener">visit our ' + esc(shop.label) + '</a>, no appointment needed)</p>'
      +   '<div class="wzc-rule"></div>'
      +   '<p class="wzc-formhead">Input your details and select a time for your call</p>'
      +   '<div data-wzc-form>'
      +     nameFields()
      +     zipField(zip, 'wzc-zp')
      +     consentBlock()
      +     errLine()
      +     '<button type="button" class="wzc-btn" data-wzc-submit aria-disabled="true">NEXT</button>'
      +   '</div>'
      +   '<div class="wzc-cal" data-wzc-cal hidden></div>'
      + '</div>';
  }

  function doneAtHomeBooked(zip, data){
    return ''
      + '<div class="wzc-card">'
      +   zipbar(zip)
      +   '<h2 class="wzc-h">You\'re booked!</h2>'
      +   '<div class="wzc-done">'
      +     '<div class="wzc-done__tick"></div>'
      +     '<h3 class="wzc-done__h">Your call is confirmed.</h3>'
      +     '<p class="wzc-done__p">A calendar invite is on its way to '
      +       esc(data.email) + ', and we\'ll text a reminder the day before.</p>'
      +     '<ul class="wzc-done__list">'
      +       '<li>On the call: we\'ll pick your bike and accessories, take a refundable '
      +         '$250 deposit, and set your delivery window.</li>'
      +       '<li>At your door: ride it on your own street. Keep it and your subscription '
      +         'starts, or send it back for a full refund.</li>'
      +     '</ul>'
      +   '</div>'
      + '</div>';
  }

  /* ==========================================================================
     OUTCOME 3  -  not in zone (waitlist)
     ========================================================================== */
  function renderOutOfZone(zip){
    return ''
      + '<div class="wzc-card" data-wzc-outcome="outOfZone">'
      +   zipbar(zip)
      +   '<h2 class="wzc-h">Sorry, we\'re not serving ' + esc(zip) + ' yet.</h2>'
      +   '<p class="wzc-sub">We\'re not offering subscription in your neighborhood yet, '
      +     'but you can still ride a Wombi. Our ExFleet bikes are available to purchase. '
      +     'Get the new bike feel, without the new bike price.</p>'
      +   '<a class="wzc-btn" href="' + esc(CONFIG.exfleetUrl) + '" data-wzc-exfleet>'
      +     'BROWSE EXFLEET BIKES</a>'
      +   '<div class="wzc-split"><span>OR</span></div>'
      +   '<p class="wzc-formhead">Get notified when we expand to your neighborhood</p>'
      +   '<div data-wzc-form>'
      +     nameFields()
      +     zipField(zip, 'wzc-zp2')
      +     consentBlock()
      +     errLine()
      +     '<button type="button" class="wzc-btn wzc-btn--ghost" data-wzc-submit aria-disabled="true">'
      +       'NOTIFY ME</button>'
      +   '</div>'
      + '</div>';
  }

  function doneOutOfZone(zip){
    return ''
      + '<div class="wzc-card">'
      +   zipbar(zip)
      +   '<h2 class="wzc-h">You\'re on the list.</h2>'
      +   '<div class="wzc-done">'
      +     '<div class="wzc-done__tick"></div>'
      +     '<h3 class="wzc-done__h">We\'ll tell you when we reach ' + esc(zip) + '.</h3>'
      +     '<p class="wzc-done__p">Where people sign up is how we decide where to go next, '
      +       'so this counts.</p>'
      +   '</div>'
      +   '<div class="wzc-split"><span>MEANWHILE</span></div>'
      +   '<p class="wzc-formhead">You can ride a Wombi today</p>'
      +   '<p class="wzc-formsub">ExFleet bikes ship anywhere. Get the new bike feel, '
      +     'without the new bike price.</p>'
      +   '<a class="wzc-btn" href="' + esc(CONFIG.exfleetUrl) + '">BROWSE EXFLEET BIKES</a>'
      + '</div>';
  }

  /* ==========================================================================
     FORM READ + VALIDATION
     ========================================================================== */
  function readForm(scope){
    var data = { firstName:'', lastName:'', mobile:'', email:'', zip:'' };
    scope.querySelectorAll('[data-wzc-field]').forEach(function(el){
      data[el.getAttribute('data-wzc-field')] = el.value.trim();
    });
    /* The phone field holds 10 auto-dashed digits; the wire value is the
       full +1-XXX-XXX-XXXX. Digits kept separately for Calendly prefill. */
    data.phoneDigits = phoneDigits(data.mobile);
    if (data.phoneDigits.length === 10){
      data.mobile = phoneDashed(data.phoneDigits);
    }
    return data;
  }

  function validate(scope, data){
    var problems = [];
    scope.querySelectorAll('.wzc-in').forEach(function(el){ el.classList.remove('is-bad'); });

    function bad(field, msg){
      problems.push(msg);
      var el = scope.querySelector('[data-wzc-field="' + field + '"]');
      if (el) el.classList.add('is-bad');
    }
    if (!data.firstName) bad('firstName','first name');
    if (!data.lastName)  bad('lastName','last name');
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(data.email)) bad('email','a valid email');
    if (data.phoneDigits.length !== 10) bad('mobile','a 10-digit phone number');

    var err = scope.querySelector('[data-wzc-formerr]');
    if (problems.length){
      err.textContent = 'We still need ' + problems.join(', ') + '.';
      err.classList.add('is-on');
      var firstBad = scope.querySelector('.wzc-in.is-bad');
      if (firstBad && firstBad.scrollIntoView) firstBad.scrollIntoView({ behavior:'smooth', block:'center' });
      return false;
    }
    err.classList.remove('is-on');
    return true;
  }

  /* ==========================================================================
     LEAD CREATION
     ========================================================================== */

  /* Jotform lead forms: the current Lead creator. Posts each submission to
     the form for its outcome (nearShop, atHome, outOfZone); each form's
     Salesforce integration creates the Lead. Phone posts as
     +1-XXX-XXX-XXXX; UTM/click-id values captured from the landing URL
     post into the hidden q18-q25 fields. */
  function postLeadForm(data, zip, outcome){
    var lf = CONFIG.leadForm;
    if (!lf.enabled) return;
    var formId = lf.formIds[outcome];
    if (!formId){
      console.error('[wzc] no Jotform lead form configured for outcome', outcome);
      return;
    }
    var f = lf.fields;
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = lf.endpoint + formId;
    form.target = 'wzc-sink';
    form.style.display = 'none';

    function add(name, value){
      if (!name) return;
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = name; i.value = value == null ? '' : value;
      form.appendChild(i);
    }
    add(f.firstName, data.firstName);
    add(f.lastName,  data.lastName);
    add(f.email,     data.email);
    add(f.mobile,    data.mobile);
    add(f.zip,       data.zip || zip);
    for (var k in lf.utmFields){
      if (lf.utmFields.hasOwnProperty(k)) add(lf.utmFields[k], UTM[k] || '');
    }

    document.body.appendChild(form);
    form.submit();
    setTimeout(function(){ form.remove(); }, 2000);
  }

  function postWebToLead(data, zip){
    var sf = CONFIG.sf;
    if (!sf.webToLead.enabled) return;
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = sf.webToLead.action;
    form.target = 'wzc-sink';
    form.style.display = 'none';

    function add(name, value){
      if (!name) return;
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = name; i.value = value == null ? '' : value;
      form.appendChild(i);
    }
    add('oid', sf.oid);
    add('recordType', sf.recordType);
    add('lead_source', sf.leadSource);
    add('currency', sf.currency);
    add('first_name', data.firstName);
    add('last_name',  data.lastName);
    add('email',      data.email);
    add('mobile',     data.mobile);
    add('zip',        zip);
    add(sf.consentField, '1');
    for (var k in sf.utmFields){
      if (sf.utmFields.hasOwnProperty(k)) add(sf.utmFields[k], UTM[k] || '');
    }
    document.body.appendChild(form);
    form.submit();
    setTimeout(function(){ form.remove(); }, 2000);
  }

  /* Booking API: DISABLED while the prod endpoint 500s. Returns a resolved
     null so the atHome flow proceeds to Calendly without a salesforce_uuid.
     Re-enable via CONFIG.sf.bookingApiEnabled when L+C fixes the endpoint. */
  function postBookingApi(data, zip){
    if (!CONFIG.sf.bookingApiEnabled){
      return Promise.resolve(null);
    }
    var payload = {
      firstName: data.firstName,
      lastName:  data.lastName,
      email:     data.email,
      postcode:  zip,
      mobile:    data.mobile,
      consentToCommunication: true,
      hearAboutUs: '',
      useCaseForBike: [],
      whatAreYouMostInterestedIn: '',
      type: 'Consultation',
      location: 'Los Angeles',
      appointmentDate: null,
      startTime: null,
      endTime: null,
      products: [],
      utm_source: UTM.utm_source, utm_medium: UTM.utm_medium,
      utm_campaign: UTM.utm_campaign, utm_content: UTM.utm_content,
      utm_term: UTM.utm_term, utm_id: UTM.utm_id,
      GCLID: UTM.gclid, FBCLID: UTM.fbclid
    };
    return fetch(CONFIG.sf.apiUrl, {
      method: 'POST',
      headers: {
        'apikey': CONFIG.sf.apiKey,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },
      body: JSON.stringify(payload)
    }).then(function(r){
      if (!r.ok){ console.error('[wzc] booking API error', r.status); return null; }
      return r.json().then(function(j){
        console.log('[wzc] booking API response', j);
        return j;
      }).catch(function(){ return null; });
    }).catch(function(e){
      console.error('[wzc] booking API request failed', e);
      return null;
    });
  }

  function extractSfId(resp){
    if (!resp) return '';
    var direct = resp.id || resp.Id || resp.leadId || resp.LeadId ||
                 resp.recordId || resp.salesforce_uuid || resp.salesforceId;
    if (direct) return String(direct);
    if (resp.data)   return extractSfId(resp.data);
    if (resp.result) return extractSfId(resp.result);
    return '';
  }

  /* ==========================================================================
     CALENDLY
     Mounts into an explicitly sized div. Custom-question prefill only runs
     when CONFIG.calendly.prefillCustomAnswers is true. While the Booking
     API is disabled there is no salesforce_uuid to carry.
     ========================================================================== */
  function loadCalendly(container, zip, data, sfId){
    container.hidden = false;
    container.innerHTML = '<div class="wzc-cal__wait">Loading available times&hellip;</div>';

    function init(){
      container.innerHTML = '';
      var mount = document.createElement('div');
      mount.style.minWidth = '320px';
      mount.style.height = '700px';
      container.appendChild(mount);

      var prefill = {
        name:      data.firstName + ' ' + data.lastName,
        firstName: data.firstName,
        lastName:  data.lastName,
        email:     data.email
      };
      if (CONFIG.calendly.prefillCustomAnswers){
        var map = CONFIG.calendly.answerMap;
        var answers = {};
        answers['a' + map.phone]    = normalizePhone(data.mobile);
        answers['a' + map.zip]      = zip;
        answers['a' + map.location] = 'Los Angeles';
        prefill.customAnswers = answers;
      }

      window.Calendly.initInlineWidget({
        url: CONFIG.calendly.url + '?hide_gdpr_banner=1'
          + (sfId ? '&salesforce_uuid=' + encodeURIComponent(sfId) : ''),
        parentElement: mount,
        prefill: prefill
      });
      container.scrollIntoView({ behavior:'smooth', block:'start' });
    }

    if (window.Calendly && window.Calendly.initInlineWidget) { init(); return; }

    if (!document.getElementById('wzc-calendly-css')){
      var css = document.createElement('link');
      css.id = 'wzc-calendly-css';
      css.rel = 'stylesheet';
      css.href = 'https://assets.calendly.com/assets/external/widget.css';
      document.head.appendChild(css);
    }
    var s = document.createElement('script');
    s.src = 'https://assets.calendly.com/assets/external/widget.js';
    s.async = true;
    s.onload = init;
    s.onerror = function(){
      container.innerHTML = '<div class="wzc-cal__wait">We couldn\'t load the calendar. '
        + 'Call us at <a href="' + CONFIG.phoneHref + '">' + CONFIG.phone
        + '</a> and we\'ll book your call.</div>';
    };
    document.head.appendChild(s);
  }

  window.addEventListener('message', function(e){
    if (!e.data || typeof e.data.event !== 'string') return;
    if (e.data.event !== 'calendly.event_scheduled') return;
    var pending = root.__wzcPending;
    if (!pending) return;
    track('zip_check_call_booked', { zip: pending.zip, zip_market: 'la' });
    out.innerHTML = doneAtHomeBooked(pending.zip, pending.data);
    setResultVisible(true);
    bindResult();
  });

  /* ==========================================================================
     RENDER + BIND
     ========================================================================== */
  function show(zip){
    out = getOut() || out;
    root = getRoot() || out;
    var ctx = classify(zip);
    console.log('[wzc] check', zip, '->', ctx.outcome);

    if (ctx.outcome === 'redirect'){
      track('zip_check', { zip: zip, zip_market: ctx.target, zip_outcome: 'redirect' });
      var url = CONFIG.redirects[ctx.target];
      out.innerHTML = '<div class="wzc-card"><div class="wzc-redirect">'
        + '<p>Good news, Wombi serves your area. Taking you to your local page&hellip;</p>'
        + '</div></div>';
      setResultVisible(true);
      revealResult();
      window.location.href = url + (url.indexOf('?') === -1 ? '?' : '&') + 'zip=' + zip;
      return;
    }

    var html;
    if (ctx.outcome === 'nearShop')      html = renderNearShop(zip, ctx);
    else if (ctx.outcome === 'atHome')   html = renderAtHome(zip, ctx);
    else                                 html = renderOutOfZone(zip);

    out.innerHTML = html;
    setResultVisible(true);
    root.__wzcCtx = ctx;
    root.__wzcZip = zip;

    track('zip_check', {
      zip: zip,
      zip_market: ctx.marketKey || 'out_of_zone',
      zip_outcome: ctx.outcome
    });
    bindResult();
    revealResult();
  }

  function reset(){
    out.innerHTML = '';
    setResultVisible(false);
    root.__wzcPending = null;
    var el = getInput();
    if (el){
      el.value = '';
      el.scrollIntoView({ behavior:'smooth', block:'center' });
      el.focus();
    }
  }

  function bindResult(){
    out.querySelectorAll('[data-wzc-reset]').forEach(function(el){
      el.addEventListener('click', reset);
    });

    /* Phone field: digits only, max 10, auto-dashed while typing.
       Pasted values are cleaned the same way (a leading 1 on an
       11-digit paste is dropped). */
    var ph = out.querySelector('[data-wzc-phone]');
    if (ph){
      ph.addEventListener('input', function(){
        ph.value = displayDashed(phoneDigits(ph.value));
      });
    }

    var consent = out.querySelector('[data-wzc-consent]');
    var submit  = out.querySelector('[data-wzc-submit]');
    if (consent && submit){
      consent.addEventListener('change', function(){
        submit.setAttribute('aria-disabled', consent.checked ? 'false' : 'true');
      });
    }

    var ex = out.querySelector('[data-wzc-exfleet]');
    if (ex){
      ex.addEventListener('click', function(){
        track('zip_check_exfleet_click', { zip: root.__wzcZip });
      });
    }

    if (submit) submit.addEventListener('click', onSubmit);
  }

  function onSubmit(e){
    var btn   = e.currentTarget;
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var card  = out.querySelector('[data-wzc-outcome]');
    var scope = out.querySelector('[data-wzc-form]');
    var outcome = card ? card.getAttribute('data-wzc-outcome') : 'atHome';
    var zip   = root.__wzcZip;
    var ctx   = root.__wzcCtx || {};
    var data  = readForm(scope);

    if (!validate(scope, data)) return;
    btn.classList.add('is-busy');

    track('zip_check_submit', {
      zip: zip,
      zip_market: ctx.marketKey || 'out_of_zone',
      zip_outcome: outcome
    });

    /* Every path: create the Lead via the Jotform form for this outcome. */
    postLeadForm(data, zip, outcome);
    postWebToLead(data, zip);

    if (outcome === 'atHome'){
      root.__wzcPending = { zip:zip, data:data };
      scope.hidden = true;
      var cal = out.querySelector('[data-wzc-cal]');
      cal.hidden = false;
      cal.innerHTML = '<div class="wzc-cal__wait">Loading available times&hellip;</div>';
      postBookingApi(data, zip).then(function(resp){
        var sfId = extractSfId(resp);
        if (!sfId) console.warn('[wzc] no Salesforce id available; booking will not carry salesforce_uuid');
        loadCalendly(cal, zip, data, sfId);
      });
      return;
    }

    if (outcome === 'nearShop'){
      out.innerHTML = doneNearShop(zip, ctx, data);
      setResultVisible(true);
      bindResult();
      return;
    }
    out.innerHTML = doneOutOfZone(zip);
    setResultVisible(true);
    bindResult();
  }

  /* ==========================================================================
     ENTRY POINT  -  the hero input drives the checker
     Listeners sit on the document and find the input and button at event
     time, so they survive the hero being redrawn by another script.
     Focusing the zip box selects the old zip, so typing replaces it
     instead of being blocked by the 5-digit limit.
     ========================================================================== */
  function check(){
    var el = getInput();
    var v = el ? (el.value || '').replace(/\D/g,'').slice(0,5) : '';
    if (isValidZip(v)){
      setHeroErr(false);
      show(v);
    } else {
      console.log('[wzc] invalid zip entered:', el ? el.value : '(no input)');
      setHeroErr(true);
      if (el) el.focus();
    }
  }

  function isZipInput(t){ return t && t.id === 'wla-zip-input'; }

  document.addEventListener('focusin', function(e){
    if (!isZipInput(e.target)) return;
    var t = e.target;
    setTimeout(function(){ try { t.select(); } catch(err){} }, 0);
  });
  document.addEventListener('input', function(e){
    if (!isZipInput(e.target)) return;
    var t = e.target;
    t.value = t.value.replace(/\D/g,'').slice(0,5);
    if (heroErrShowing() && isValidZip(t.value)) setHeroErr(false);
  });
  document.addEventListener('keydown', function(e){
    if (!isZipInput(e.target)) return;
    if (e.key === 'Enter' || e.keyCode === 13){
      e.preventDefault();
      check();
    }
  });
  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest ? e.target.closest('#wla-zip-btn') : null;
    if (!t) return;
    e.preventDefault();
    check();
  });

  console.log('[wzc] zip checker v27 ready');

  // deep link support: this page ?zip=91101 auto-runs the result
  var qs = new URLSearchParams(window.location.search);
  var pre = qs.get('zip');
  if (pre && isValidZip(pre)){ input.value = pre; show(pre); }
})();